import { mapGetters, mapMutations } from 'vuex';
import { planTypes, } from '@/common/constants';
import { AddOrRemoveBasePlanActionTypes } from '../constants';
import { getPlanTotalLicense } from '@/common/service/validate';
import canAutoAdd from '@/components/capacity/mx/canAutoAdd';

export default {
  mixins: [canAutoAdd],
  data() {
    return {
      title: '',
      msgInstance: null,
      visibleCapacityList: [],
    };
  },
  computed: {
    ...mapGetters([
      'getBoughtMeetingPlans',
    ]),
    mx_getBoughtOrBuyingBasePlans() {
      const boughtMeetingPlans = this.getBoughtMeetingPlans;
      const {
        category: basePlanCategory,
        billing_cycle: basePlanBillingCycle,
        planNameKey,
        typeNameKey,
        type: basePlanType,
      } = boughtMeetingPlans[0] || this.currentBasePlans[0];
      const basePlanName = this.$t(planNameKey) || this.$t(typeNameKey);
      const currentBasePlanQuantity = boughtMeetingPlans[0] ? getPlanTotalLicense(boughtMeetingPlans) : 0;
      return {
        basePlanCategory,
        basePlanBillingCycle,
        basePlanType,
        basePlanName,
        planNameKey,
        typeNameKey,
        currentBasePlanQuantity,
      };
    },
    mx_plansSortedByMaximumCount() {
      return this.mx_currentPlans.sort(
        (itemPrev, itemNext) => (itemNext.cartInfo?.selected_number || 0) - (itemPrev.cartInfo?.selected_number || 0),
      );
    },
    // For multiple capacities plans to pick the largest license count
    mx_peakCapacityLicenseCount() {
      const peakPlan = this.mx_plansSortedByMaximumCount[0];
      return peakPlan?.cartInfo?.selected_number || 0;
    },
    mx_planLicenseCount() {
      // could be override by specific requirement
      return this.mx_peakCapacityLicenseCount;
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlanByCategory', 'setUpdateBasePlan', 'addOrRemoveBasePlan']),
    mx_checkCapacityChanged(newPlan) {
      const { type: basePlanType } = this.getBoughtMeetingPlans[0] || this.currentBasePlans[0];
      this.hasModifyCapacity = newPlan.category !== this.currentEditPlan.category;
      if (this.hasModifyCapacity) {
        this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.REMOVE, planType: planTypes[basePlanType] });
      }
    },
    mx_plansFilteredByCapacityKey(capacity, capacityKey) {
      return this.mx_currentPlans.filter((item) => item[capacityKey] === capacity);
    },
    // For chosen specific capacity key license count
    mx_totalCapacityLicenseCount(capacity, capacityKey = this.capacityKey) {
      const chosenPlans = this.mx_plansFilteredByCapacityKey(capacity, capacityKey);
      return getPlanTotalLicense(chosenPlans);
    },
    mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, basePlanNewSelectorNumber) {
      this.updateSelectPlanByCategory({
        category: basePlanCategory,
        billingCycle: basePlanBillingCycle,
        cartInfo: { selected_number: basePlanNewSelectorNumber },
      });
      this.$nextTick(() => {
        this.setUpdateBasePlan({ update: true, from: this.title, autoAdd: true }); // Ensure the triggering of the watch in ZOOM_MEETING/edit.
      });
    },
    mx_onAddedBasePlan() {
      // no-op
    },
    mx_onRemovedBasePlan() {
      // no-op
    },
  },
  watch: {
    mx_planLicenseCount: {
      immediate: true,
      handler(nv) {
        if (!this.mx_canAutoAdd) return;

        const { basePlanCategory, basePlanBillingCycle, basePlanType, basePlanName, currentBasePlanQuantity } =
          this.mx_getBoughtOrBuyingBasePlans;
        if (nv > currentBasePlanQuantity) {
          if(!this.getSelectedPlans.map(e => e.type).includes(basePlanType)) {
            this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.ADD, planType: planTypes[basePlanType] });
            this.mx_onAddedBasePlan(basePlanName);
          }
          // If auto replenish selected number to base plan
          this.mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, nv);
        } else if (nv <= currentBasePlanQuantity && this.getSelectedPlans.map(e => e.type).includes(basePlanType)) {
          this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.REMOVE, planType: planTypes[basePlanType] });
          this.mx_onRemovedBasePlan(basePlanName);
        }
      },
    },
  },
};
